import {FC} from 'react'

import {getPricingContent, PricingTabContent, pricingTabs} from '@/content/pricing'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {PricingTabType} from '@/utils/pricing'
import {routeTo} from '@/utils/router'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Tab} from '../common/content/tabs/Tab'
import {Tabs} from '../common/content/tabs/Tabs'
import {PricingBrandProtectionTab} from './brand-protection/PricingBrandProtectionTab'
import {PricingLegalServicesTable} from './services/PricingLegalServicesTable'
import {PricingTrademarkOwnershipTransferTable} from './trademark-ownership-transfer/PricingTrademarkOwnershipTransferTable'
import {PricingTrademarkRegistrationTable} from './trademark-registration/PricingTrademarkRegistrationTable'
import {PricingTrademarkRenewalTable} from './trademark-renewal/PricingTrademarkRenewalTable'

const pricingTabEntries = Object.entries(pricingTabs) as [PricingTabType, PricingTabContent][]

type PricingTabsProps = {
  activeTab: PricingTabType
}

export const PricingTabs: FC<PricingTabsProps> = ({activeTab}) => {
  const {t} = useTranslation()
  const {legalServices} = getPricingContent()

  const getActiveTab = (tab: PricingTabType) => {
    switch (tab) {
      case PricingTabType.LegalServices:
        return <PricingLegalServicesTable subtitle={t(legalServices.subtitle)} />
      case PricingTabType.BrandProtection:
        return <PricingBrandProtectionTab />
      case PricingTabType.TrademarkRenewal:
        return <PricingTrademarkRenewalTable />
      case PricingTabType.TrademarkOwnershipTransfer:
        return <PricingTrademarkOwnershipTransferTable />
      default:
        return <PricingTrademarkRegistrationTable />
    }
  }

  return (
    <>
      <div className="wrapper">
        <Tabs isCentered>
          {pricingTabEntries.map(([tab, {title}]) => (
            <Tab
              key={tab}
              title={t(title)}
              linkHref={routeTo.pricing(
                tab === PricingTabType.TrademarkRegistration ? undefined : tab,
              )}
              isActive={tab === activeTab}
              isPageLink
            />
          ))}
        </Tabs>
      </div>
      {getActiveTab(activeTab)}

      <style jsx>{`
        .wrapper {
          margin-top: ${theme.spacing[6]};
        }
        @media ${MOBILE_SCREENSIZE} {
          .wrapper {
            margin-top: ${theme.spacing[4.5]};
          }
        }
      `}</style>
    </>
  )
}
